import fetch from '../utilities/fetchAxios'

export const getCorporateGroups = async (query?: any) => {
  const method = 'GET'
  const path = '/corporate-group/v1'
  return fetch(method, path, query)
}
